export default {
  homepage: "ドラッグストア",
  homepageCrumb: "ホーム",
  setting: "表示の設定",
  storeManagement: "店舗管理",
  storeDevice: "端末一覧",
  storeAdvertisement: "広告/販促枠の表示",
  storeCatalogTitle: "カテゴリー",
  storeCatalogBreadcrumb: "カテゴリー一覧",
  storeProductDisplay: "表示商品一覧",
  productManagement: "商品管理",
  productDetail: "商品確認",
  productDetailUpdate: "商品編集",
  tagManagement: "タグ管理",
  userManagement: "ユーザー管理",
  logout: "ログアウト",

  workManagement: "ドラッグストア",
  workAdd: "業務追加",
  workDetail: "業務詳細",
  performanceManagement: "実績管理",
  performanceDetail: "実績詳細 ",
  performanceUpdate: "実績編集",
  workerManagement: "ワーカー管理",
  workerAdd: "ワーカー追加",
  workerEdit: "ワーカー編集",
  workerDetail: "ワーカー詳細",
  userCreate: "ユーザー追加",
  userDetail: "ユーザー詳細",
  userEdit: "ユーザー編集",
}
